import { DoctoFaturaArquivo } from './doctoFaturaArquivo';

export class EnvioAnexoEmail {
    UsuarioId: number;
    Arquivos: DoctoFaturaArquivo[];
}